window.onload = function () {

  setTimeout(() => {
    document.body.classList.add('gsap');
  }, 100);

  gsap.registerPlugin(ScrollTrigger);
  //ScrollTrigger.config({ ignoreMobileResize: true });
  // ScrollTrigger.normalizeScroll(true); // enable

  if (document.querySelector('.p-mining')) {
    ScrollTrigger.normalizeScroll({
      allowNestedScroll: true,
    });
  }




  // ============
  const prlx = gsap.utils.toArray('[data-prlx]');
  prlx.forEach((item) => {
    const itemData = item.getAttribute('data-prlx').split(',');
    const shift = 100 * itemData[0];
    let moveDown = itemData[1] ? itemData[1] : 0.1;
    if (itemData[2] && window.matchMedia('(max-width: 767px)').matches) {
      moveDown = itemData[2];
    }
    gsap.set(item, {
      y: `${shift * moveDown}vh`
    });
    gsap.to(item, {
      y: `-${shift * (1 - moveDown)}vh`,
      ease: 'none',
      scrollTrigger: {
        // markers: true,
        trigger: item,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 0,
        invalidateOnRefresh: true
      }
    });
  });
  // ============


  if (document.querySelector('.js_pin')) {
    if (document.querySelector('.js_pin').classList.contains('js_pin_md') && window.matchMedia("(min-width: 768px)").matches || !document.querySelector('.js_pin').classList.contains('js_pin_md')) {
      let endAm = '+=4200';
      if (window.matchMedia('(max-width: 767.92px)').matches) {
        endAm = '+=2800';
      }
      const tl1 = gsap.timeline({
        scrollTrigger: {
          trigger: '.js_pin',
          start: 'center center',
          end: endAm,
          // scrub: 0.5,
          scrub: 0,
          pin: '.js_pin-wrapper',
          // once: true,
          onLeave: function (self) {
            self.scroll(self.start);	// <-- sets position to start of ScrollTrigger
            self.disable();
            self.animation.progress(1);
            document.body.classList.add('m-unpinned');
            swipableCards(self.trigger);
            setTimeout(() => {
              self.trigger.classList.add('m-hasarrows');
            }, 10);
          }
          // markers: true,
        }
      });


      const pinplates = gsap.utils.toArray('.js_pinplate');
      pinplates.forEach((item, i) => {
        let pDelay = 1;
        if (i === 0) {
          pDelay = 0;
        }
        tl1.to(item, { opacity: 1, y: -180, delay: pDelay });
      });
    }
    else {
      console.log(123);
      document.querySelector('.js_pin').classList.add('m-hasarrows');
      document.body.classList.add('m-unpinned');
      swipableCards(document.querySelector('.js_pin'));
    }
  }



  // ============
  if (document.querySelector('[data-prlx2]')) {
    gsap.to('[data-prlx2]', {
      y: (i, el) => (1 - parseFloat(el.getAttribute('data-prlx2'))) * ScrollTrigger.maxScroll(window),
      ease: 'none',
      scrollTrigger: {
        start: 0,
        end: 'max',
        invalidateOnRefresh: true,
        scrub: 0,
      }
    });
  }
  // ============

  if (document.querySelector('.js_fixedh_color')) {
    gsap.to('.js_fixedh_color', {
      color: '#43ab90',
      ease: 'none',
      scrollTrigger: {
        // markers: true,
        // trigger: item,
        // start: 'top bottom',
        start: 0,
        // end: 'bottom top',
        end: '+=600',
        scrub: 0,
        invalidateOnRefresh: true,
      }
    });
  }
  if (document.querySelector('.js_fixedh_opacity')) {
    gsap.to('.js_fixedh_opacity', {
      opacity: 0,
      ease: 'none',
      scrollTrigger: {
        // markers: true,
        // trigger: item,
        // start: 'top bottom',
        start: 0,
        // end: 'bottom top',
        end: '+=50',
        scrub: 0,
        invalidateOnRefresh: true,
      }
    });
  }


  // ============
  // gsap.utils.toArray('[data-move]').forEach((item, i) => {
  //   let heightDiff = 100;
  //   if (item.getAttribute('data-move')) heightDiff = item.getAttribute('data-move') / 2;

  //   gsap.fromTo(item, {
  //     y: heightDiff
  //   }, {
  //     scrollTrigger: {
  //       trigger: item,
  //       scrub: true
  //     },
  //     y: -heightDiff,
  //     ease: 'none'
  //   });
  // });
  // ============

  // gsap.registerPlugin(ScrollTrigger);

  // gsap.to('.pinplate.m-uno', {
  //   scrollTrigger: {
  //     trigger: '.s-pin',
  //     markers: true,
  //     start: 'center center',
  //     end: '+=1400',
  //     pin: '.s-pin',
  //     scrub: 0,
  //     invalidateOnRefresh: true,
  //   },
  //   opacity: 1,
  //   y: -200,
  // });



}



// =============
// swipe cards stuff

let holdYourSwipe = false;
function swipableCards(swipeCardsSection) {

  let touchstartX = 0;
  let touchendX = 0;
  const treshold = 90;

  const currentCard = swipeCardsSection.querySelector('.js_pinplate:last-child');
  currentCard.classList.add('m-active');

  const btnPrev = swipeCardsSection.querySelector('.js_swipecard_prev');
  const btnNext = swipeCardsSection.querySelector('.js_swipecard_next');

  btnPrev.addEventListener('click', (e) => {
    if (!holdYourSwipe) {
      swipeCard(swipeCardsSection, 'prev');
    }
  });
  btnNext.addEventListener('click', (e) => {
    if (!holdYourSwipe) {
      swipeCard(swipeCardsSection, 'next');
    }
  });

  swipeCardsSection.addEventListener('touchstart', (e) => {
    touchstartX = e.changedTouches[0].screenX;
    // console.log(touchstartX);
  });
  swipeCardsSection.addEventListener('touchend', (e) => {
    touchendX = e.changedTouches[0].screenX;
    // console.log(touchendX);
    // console.log(Math.abs(touchendX - touchstartX));
    if (!holdYourSwipe && Math.abs(touchendX - touchstartX) > treshold) {
      if (touchendX > touchstartX) {
        swipeCard(swipeCardsSection, 'next');
      }
      if (touchendX < touchstartX) {
        swipeCard(swipeCardsSection, 'prev');
      }
    }
  });
}


function swipeCard(swipeCardsSection, direction) {

  holdYourSwipe = true;

  const activeCard = swipeCardsSection.querySelector('.js_pinplate.m-active'),

    prevCard = activeCard.previousElementSibling ? activeCard.previousElementSibling : swipeCardsSection.querySelector('.js_pinplate:last-child'),

    nextCard = activeCard.nextElementSibling ? activeCard.nextElementSibling : swipeCardsSection.querySelector('.js_pinplate:first-child');


  activeCard.classList.remove('m-active');

  let addIndex = -1,
    targetCard = activeCard;

  if (direction === 'prev') {
    nextCard.classList.add('m-active');
    // nextCard.classList.add('m-moveleft');
    nextCard.classList.add('m-moveright');

    addIndex = 1;
    targetCard = nextCard;
  }
  else {
    prevCard.classList.add('m-active');
    activeCard.classList.add('m-moveright');
  }
  const newZindex = targetCard.style.zIndex ? parseInt(targetCard.style.zIndex, 10) + addIndex : addIndex;
  setTimeout(() => {
    targetCard.classList.remove('m-moveright', 'm-moveleft');
    targetCard.style.zIndex = newZindex;
    holdYourSwipe = false;
  }, 200);



}


  // =============


